import { render, staticRenderFns } from "./df-page-pdf.vue?vue&type=template&id=2c5fe136&"
import script from "./df-page-pdf.ts?vue&type=script&lang=js&"
export * from "./df-page-pdf.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports